export default class ResultCode {
  static Success = 0; // 성공
  static Failed = -1; // 실패
  static Unauthorized = 401; // Unauthorized
  static NotExistSession = 11001; // 세션이 없습니다.
  static ExistSession = 11002; // 세션이 있습니다.
  static NotMatchIdorPw = 10001; // 회원 - 아이디나 비밀번호가 맞지 않습니다.
  static RemoveAccount = 10002; // 회원 - 탈퇴된 계정입니다.
  static UserUpdateError = 10003; // 회원 - 수정 중 오류가 발생했습니다.
  static ExistEmail = 10004; // 중복된 이메일입니다.
  static AppBuildFailed = 20001; // 앱 - 생성중 오류가 발생했습니다.
  static AppCloneFailed = 20002; // 앱 - 복제 중 오류가 발생했습니다.
  static ApiEmptyParameter = 30001; // Api - 저장된 값이 없습니다
  static GroupDeleteFailed = 40001; // 삭제 중 오류가 발생했습니다.
  static WorkflowDeleteFailed = 60001; // 삭제 중 오류가 발생했습니다.
  static WorkflowUpdateFailed = 60002; // 수정 중 오류가 발생했습니다.
  static AlreadyExist = 60010; // 이미 등록이 되어있습니다.
  static NoZapierAuth = 60011; // 유효한 Api Key가 아닙니다.
  static BadParams = 98001; // 파라미터가 유효하지 않습니다.
  static DbFailed = 99001; // DB 실패
  static get(code /*: number */) {
    switch (code) {
      case 0:
        return '성공';
      case -1:
        return '실패';
      case 401:
        return 'Unauthorized';
      case 11001:
        return '세션이 없습니다.';
      case 11002:
        return '세션이 있습니다.';
      case 10001:
        return '회원 - 아이디나 비밀번호가 맞지 않습니다.';
      case 10002:
        return '회원 - 탈퇴된 계정입니다.';
      case 10003:
        return '회원 - 수정 중 오류가 발생했습니다.';
      case 10004:
        return '중복된 이메일입니다.';
      case 20001:
        return '앱 - 생성중 오류가 발생했습니다.';
      case 20002:
        return '앱 - 복제 중 오류가 발생했습니다.';
      case 30001:
        return 'Api - 저장된 값이 없습니다';
      case 40001:
        return '삭제 중 오류가 발생했습니다.';
      case 60001:
        return '삭제 중 오류가 발생했습니다.';
      case 60002:
        return '수정 중 오류가 발생했습니다.';
      case 60010:
        return '이미 등록이 되어있습니다.';
      case 60011:
        return '유효한 Api Key가 아닙니다.';
      case 98001:
        return '파라미터가 유효하지 않습니다.';
      case 99001:
        return 'DB 실패';
    }
    return 'Uknown';
  }
}
